import logger from "redux-logger";
import { DELETE_EMAIL_TEMPLATE_CATEGORY, GET_EMAIL_TEMPLATE_CATEGORY, POST_EMAIL_TEMPLATE_CATEGORY, PUT_EMAIL_TEMPLATE_CATEGORY } from "../constants/actionTypes";

const initialState = {
    emailTemplateCategoryList: [],
};

const emailTemplateCategoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_EMAIL_TEMPLATE_CATEGORY:
            return {
                ...state,
                emailTemplateCategoryList: action.payload,
            };
        case POST_EMAIL_TEMPLATE_CATEGORY:
            return {
                ...state,
                emailTemplateCategoryList: [...state.emailTemplateCategoryList, action.payload],
            };
        case PUT_EMAIL_TEMPLATE_CATEGORY:
            const updatedList = state.emailTemplateCategoryList.map((category) =>
                category.id === action.payload.id ? action.payload : category
            );
            return {
                ...state,
                emailTemplateCategoryList: updatedList,
            };

        case DELETE_EMAIL_TEMPLATE_CATEGORY:
            const filteredList = state.emailTemplateCategoryList.filter(
                (category) => category.id !== action.payload
            );
            return {
                ...state,
                emailTemplateCategoryList: filteredList,
            };
        default:
            return state;
    }
};

export default emailTemplateCategoryReducer;